module.exports = __webpack_public_path__ + "static/media/eric.40b16bb0.jpg";